<div class="disable-confirm-container">
    <p class="disable-confirm-title alt-inter-bold alt-size-20">{{"USERS.enable" | translate }} </p>
    <p class="disable-confirm-text-one alt-size-14 alt-inter-semibold ">{{"USERS.enable-text-modal" | translate}} "{{data.title}}" ?</p>
    <small class="disable-confirm-text-two alt-size-14 alt-inter-regular">{{"USERS.enable-text-two" | translate}}</small>


    <div class="btn-proceed alt-flex-end">
      <button class="btn-cancel alt-color-bran1 pointer alt-inter-medium  alt-size-14" type="button" [mat-dialog-close]="false" >{{"USERS.go-back" | translate | uppercase }}</button>
      <button class="btn-agree alt-color-bran1 pointer  alt-inter-medium  alt-size-14 "  type="button" [mat-dialog-close]="true">{{"USERS.agree" | translate | uppercase
        }}</button>
    </div>
  </div>
